@if (topNavigationDetails && topNavigationPermissions) {
  <header>
    <div class="header-layout">
      <img [src]="agencyBranding()?.agencyLogoPath"
           alt="Agency Logo">
      <nav>
        @if (applicantId) {
          <input type="checkbox"
                 class="toggler"
                 aria-label="Toggle navigation menu">
        }
        @if (applicantId) {
          <div class="hamburger">
            <div></div>
          </div>
        }
        @if (topNavigationDetails?.isAuthenticated) {
          <div class="nav-menu">
            <div class="overlay"></div>
            <div class="navigation-menu-list">
              @if (applicantId) {
                <ul>
                  <li><a [href]="homePageLink">Home</a></li>
                  @if (topNavigationPermissions.canDisplayPolicies) {
                    <li><a [href]="policyLink">Policies</a>
                      @if (topNavigationPermissions.canDisplayPolicyIndicator) {
                        <span class="new-indicator"></span>
                      }
                    </li>
                  }
                  <li><a [href]="documentLink">Documents</a></li>
                  @if (topNavigationPermissions.canDisplayCertificates) {
                    <li><a [href]="certificateLink">Certificates</a></li>
                  }
                  @if (topNavigationPermissions.canDisplayPayments) {
                    <li><a [href]="paymentLink">Payments</a></li>
                  }
                  @if (topNavigationPermissions.hasClaims) {
                    <li><a [href]="claimsLink">Claims</a></li>
                  }
                  @if (hasIntegration) {
                    <li><a [href]="quotesLink">Products</a></li>
                  }
                  @if (topNavigationPermissions.canDisplayProposals || isPreview) {
                    <li [routerLink]="['my-quotes']"><a>My Quotes</a>
                      @if (topNavigationPermissions.isNewProposal) {
                        <span class="new-indicator"></span>
                      }
                    </li>
                  }
                </ul>
              }
              @if (applicantId) {
                <span class="icon-ellipse"></span>
              }
              <div class="user-profile">
                <button class="profile-dropdown"
                        type="button"
                        (click)="displayProfileOptions($event)">
                  <span class="icon-person"></span>
                  <span class="icon-angle-down"></span>
                </button>
                @if (topNavigationDetails?.isAgentView) {
                  <span>Read Only Mode</span>
                }
                @if (showProfileOptions) {
                  <div class="profile-options">
                    <ul>
                      @if (applicantId) {
                        <li><a [href]="myAccountLink">My Account</a></li>
                      }
                      @if (showSwitchAccountsLink) {
                        <li><a [href]="switchAccountsLink">Switch Accounts</a></li>
                      }
                      <li><a [href]="logOutLink">Log Off</a></li>
                    </ul>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </nav>
    </div>
  </header>
}